import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';
import { TranslateService }                     from '@ngx-translate/core';

import { CriticalMessageModel }    from './typings/critical-message';
import { CriticalMessagesService } from './critical-messages.service';
import { MessagesService }         from '../messages.service';

@Component({
  selector   : 'verify-critical-message',
  template: require('./critical-messages.verify.component.html')
})
export class VerifyCriticalMessageComponent {
  @BlockUI('verifyCriticalMessageBlock') block : NgBlockUI;

  @Input() message: CriticalMessageModel;

  verificationCode: string;

  constructor (
    public  activeModal            : NgbActiveModal,
    @Inject(forwardRef(() => CriticalMessagesService))
    private criticalMessagesService: CriticalMessagesService,
    private messagesService        : MessagesService,
    private  translateService      : TranslateService,
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.criticalMessagesService.validateCode(this.verificationCode, this.message)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.CODE_VERIFIED'), 'success');

      this.activeModal.close();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
